import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { dismissAllMessages } from '../UserMessaging'
import { translateResourceString } from '../../../util/translationUtility';

import { toPayment, toShipping } from './navigationActionCreators';


class CheckoutNavigation extends React.Component {
    constructor(props) {
        super(props);
        this.onToShipping = this.onToShipping.bind(this);
    }

    onToShipping() {
        this.props.onToShipping();
      }

    render() {
       return (
        <div className="checkout-navigation-wrapper">
            <nav aria-label="checkout-navigation" >
                <ol className="checkout-navigation">
                    <li className="checkout-navigation-item">
                        <a href={this.props.cartLink}> 
                        {translateResourceString("/Checkout/Navigation/CartPageLink")}
                        </a>
                    </li>

                    <li className={`checkout-navigation-item ${this.props.onShippingScreen ? "active" : ""}`}  onClick={(e) => this.onToShipping(e)}>{translateResourceString("/Checkout/Navigation/Shipping")}</li>
                    <li className={`checkout-navigation-item ${this.props.onPaymentScreen ? "active" : ""} ${this.props.onShippingScreen ? "disabled" : ""}`}>{translateResourceString("/Checkout/Navigation/Payment")}</li>
                </ol>
            </nav>
        </div>
        );
    }
}

CheckoutNavigation.propTypes = {
    onPaymentScreen: PropTypes.bool,
    onShippingScreen: PropTypes.bool,
    cartLink: PropTypes.string
}

const mapCheckoutNavigationStateToProps = (state) => {
    return {
        onPaymentScreen: state.ui.onPaymentScreen,
        onShippingScreen: !!!state.ui.onPaymentScreen,
        cartLink: state.constants.navigation.shoppingCartUrl,
    };
}

const mapCheckoutNavigationDispatchToProps = (dispatch) => {
    return {
        onToPayment: () => {
            dispatch(dismissAllMessages());
            dispatch(toPayment());
        },
        onToShipping: () => {
            dispatch(dismissAllMessages());
            dispatch(toShipping());
        }
    }
}

const CheckoutNavigationContainer = connect(mapCheckoutNavigationStateToProps, mapCheckoutNavigationDispatchToProps)(CheckoutNavigation);

export default CheckoutNavigationContainer